import React, { Fragment, useEffect, useState } from "react";
import { accountDropdownItems } from "./accountItems";
import { Link } from "react-router-dom";
import "./Dropdown.css";
import UserInfo from "./UserInfo";
import store from '../../../redux/store';
import { useSelector, useDispatch } from 'react-redux';
// import { getCurrentUser, userInfo } from "../../../redux/actions/userAction";
import LoginLink from '../../layout/accountDropdown/LoginLink';
import Cookies from 'js-cookie';
// import { isLoggedIn } from '../../../redux/actions/userAction';


import UserLogout from "./UserLogout";
// import { getCurrentUser, getUserDetails, userLoggedIn } from "../../../redux/actions/userAction";

function Dropdown({ slModalOpen, handleFormType, loggedIn}) {
  const user = useSelector((state) => state.user);
  const userInfoData = Cookies.get('userData');
  const userInfodataLs = JSON.parse(localStorage.getItem('userData'));

  const dispatch = useDispatch();
  const [click, setClick] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);

  const handleClick = () => {
    setClick(!click);
    document.querySelector('.account_link_submenu').classList.toggle('open');
  }

  return (
    <Fragment>
      <ul onClick={handleClick}
        className={click ? "account_link_submenu clicked right-12" : "account_link_submenu open"}
        >
        {loggedIn ? <UserInfo userInfoData={userInfoData} userInfodataLs={userInfodataLs}/> : <LoginLink slModalOpen={slModalOpen} handleFormType={handleFormType} />}
        {accountDropdownItems.map((item) => {
          return (
            <li key={item.id}>
              <Link
                to={item.path}
                className={item.cName}
                onClick={() => setClick(false)}
              >
                <span className="dropdwn_icon_box">{item.icon}</span><span className="link_item_title">{item.title}</span>
              </Link>
            </li>
          );
        })}
        <li>
          {loggedIn ? <UserLogout /> : null}
        </li>
      </ul>
    </Fragment>
  );
}

export default Dropdown;